<template>
    <div>
        <router-link to="/news" class="notice-bar-link">
            <div class="notice-bar">
                <span>{{ noticeText }}</span>
                <span class="notice-bar-arrow">
                    <svg data-slot="icon" fill="none" stroke-width="2" width="22" height="22" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m12.75 15 3-3m0 0-3-3m3 3h-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"></path>
                    </svg>
                </span>
            </div>
        </router-link>
    </div>
</template>

<script>
import { getLatestUpdate, getNoticeBarText } from '@/utils/updateDataManager.js';

export default {
  name: 'NoticeBar',
  computed: {
    noticeText() {
      const latestUpdate = getLatestUpdate();
      return getNoticeBarText(latestUpdate);
    }
  }
};
</script>

<style scoped>
.notice-bar-link{
  text-decoration: none;
}
.notice-bar{
  max-width: 1080px;
  margin: 0 auto;
  display: block;
  width: 100%;
  background-color: #ffa4b0;
  color: #fff;
  text-align: center;
  padding: 12px 0;
  border-radius: 24px;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 32px;
}
.notice-bar-arrow{
  margin-left: 32px;
}
.notice-bar-arrow svg{
  vertical-align: -5px;
}
</style>